import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const clients = [
  { name: "Apple", logo: "/images/apple.png" },
  { name: "FIRST Group", logo: "/images/first-group.svg" },
  { name: "FIRST Property", logo: "/images/first-property.svg" },
  { name: "Mac Expert", logo: "/images/mac-expert.png" },
  { name: "Koosmik", logo: "/images/koosmik.webp", invert: true }
];

export const TrustedBy = () => {
  const sectionRef = useRef(null);
  const logosRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(logosRef.current, {
        y: 30,
        opacity: 0,
        duration: 0.6,
        stagger: 0.1,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 85%",
          toggleActions: "play none none reverse"
        }
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-16 md:py-20 bg-obsidian border-y border-concrete/10"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <p className="text-center text-xs uppercase tracking-[0.3em] text-concrete/40 mb-12">
          Companies & Partnerships
        </p>

        <div className="flex flex-wrap items-center justify-center gap-12 md:gap-16">
          {clients.map((client, index) => (
            <div
              key={client.name}
              ref={(el) => logosRef.current[index] = el}
              className="h-8 md:h-10 opacity-60 hover:opacity-100 transition-opacity duration-300"
            >
              <img
                src={client.logo}
                alt={client.name}
                className={`h-full w-auto object-contain ${client.invert ? 'invert' : ''}`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
